import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const ADDRESS_API_URL = `${API_HOST}/api/address`;
const COUNTY_API_URL = `${ADDRESS_API_URL}/county`;

function* getCounties() {
  yield takeEvery(actions.GET_COUNTIES, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], COUNTY_API_URL);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_COUNTIES_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getCounties)]);
}
